import React from 'react'
import { Base, Header, Stack } from '@crossfit/ui'

import Tag from 'pages/Programming/components/Tag'
import { ProgrammingClassType } from '../types'
import { useUnitPreference } from '../components/UnitPreference'
import ToggleSwitch from 'components/ToggleSwitch'
import style from './style.module.css'

type Props = {
  name: string
  type: ProgrammingClassType
}

function DailyClassPlanHeader({ name, type }: Props) {
  const { unitPreference, toggleUnitPreference } = useUnitPreference()
  return (
    <>
      <Base as='header' className={style.mainHeader} mb={8}>
        <Stack
          as='header'
          direction='horizontal'
          style={{ alignItems: 'flex-end' }}
          mb={3}
          spacing={[5, 3]}
        >
          <Header size='xlarge' as='h2'>
            {name}
          </Header>
          {type && type !== ProgrammingClassType.RestDay && (
            <Tag className={style.tag}>{type}</Tag>
          )}
        </Stack>
        <ToggleSwitch
          options={['Imperial', 'Metric']}
          selectedOption={unitPreference}
          onClick={toggleUnitPreference}
        />
      </Base>
      {type === ProgrammingClassType.RestDay && (
        <Header size='medium' as='h3' mb={4}>
          {type}
        </Header>
      )}
    </>
  )
}

export default DailyClassPlanHeader
